import { request } from './reducers/query';

// eslint-disable-next-line import/no-default-export
export default {
    PAYMENTS_SEARCH_REQUEST: request,
};
